var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 14.1558C28 21.8877 21.732 28.1558 14 28.1558C6.26801 28.1558 0 21.8877 0 14.1558C0 6.42377 6.26801 0.155762 14 0.155762C21.732 0.155762 28 6.42377 28 14.1558ZM19.1946 7.60227L5.69622 12.8068C4.77105 13.1685 4.78738 13.6807 5.53755 13.9187L8.99323 14.9967L17.0094 9.94964C17.3816 9.7023 17.7269 9.8423 17.4446 10.0908L10.9579 15.951L10.7094 19.5129C11.0711 19.5129 11.2286 19.3554 11.4152 19.1688L13.1034 17.5424L16.6034 20.1219C17.2416 20.4836 17.6977 20.2969 17.8681 19.5293L20.1664 8.70129L20.1652 8.70245C20.3682 7.75511 19.8211 7.37594 19.1946 7.60227Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.17944ccc8757a7584927c1586a07d1ee.svg";
export { ForwardRef as ReactComponent };